import React from "react";
import "./BonusApp.scss";
import { setItem } from "../../util/util";
import http from "../../util/api";
import {Toast, Icon, SearchBar } from "antd-mobile";
import qs from "qs";
import Loading from "../../components/Loading";
const mapping=[
  {
    eventId:'685108179250',
    rankResid:'685990220046',
    bonusResid:'685116756229',
    brid:'打标签积分规则'
  }
]
class BonusApp extends React.Component {
  state = {
    loading:false,
    toUse:'',
    userData:{
    },
    bonusData:{
    },
    discription:'',
    rankResid:''
  };
  judgeNum=(v)=>{
    if(isNaN(v)){
      Toast.fail('输入的值必须是数字',3);
    }else{
      let _v=Number(v);
      if(_v<=0){
        Toast.fail('输入的值必须大于0',3);
      }else if(_v>Number(this.state.bonusData.bonus)){
        Toast.fail('输入的值不能大于可用积分',3);
      }else{
        this.setState({toUse:v});
      }
    }
  }
  async componentDidMount() {
    let token=localStorage.getItem('AccessToken');
    if(token){
      this.getData();
    }else{
      this.props.history.push('/login');}
  }
  getData=async()=>{
    const search = document.location.search;
    const querystring = search.substring(1);
    const { eventId } = qs.parse(querystring);
    let rankResid='';
    let bonusResid='';
    let brid='';
    if(!eventId){
      Toast.fail('未能获取到活动');
      return false;
    }else{
      let n =0;
      while(n<mapping.length){
        if(mapping[n].eventId==eventId){
          rankResid=mapping[n].rankResid;
          bonusResid=mapping[n].bonusResid;
          this.setState({bonusResid});
          brid=mapping[n].brid;
        }
        n++;
      }
    }
    this.setState({loading:true});

    try{
      let res = await http().getRecordAndSubTables({
        resid:685988118358,
        subresid:rankResid,
        getsubresource: 1,
      });
      let res2 = await http().getTable({
        resid:685126368952,
        cmswhere:`brid = '${brid}'`
      });
      console.log(res,res2)
      if(res.data.data.length>0){
        this.setState({userData:res.data.data[0]});
        if(res.data.data[0][rankResid].length>0){
          this.setState({bonusData:res.data.data[0][rankResid][0]});
        }
      }
      if(res2.data.data.length>0){
        this.setState({discription:res2.data.data[0].contenText});
      }
      this.setState({loading:false});
    }catch(e){
      console.error(e);
      if(e.message=='loginerror'){
        this.props.history.push('/login');
      }
      Toast.fail(e.message);
      this.setState({loading:false});
    }
  }
  submit=async()=>{
    this.setState({loading:true});
    let phone = localStorage.getItem('UserCode')
    let obj={
      phone,
      creatReason:'积分兑换',
      eventRecid:this.state.bonusData.eventRecid,
      symbol:'减',
      tradeValue:this.state.toUse
    }
    try{
      let res = await http().addRecords({
        resid:this.state.bonusResid,
        data:[obj]
      });
      this.setState({loading:false});
      Toast.success('申请成功！',1)
      this.props.history.push('/bonus?eventId='+this.state.bonusData.eventRecid)
    }catch(e){
      console.error(e);
      Toast.fail(e.message);
      this.setState({loading:false});
    }
  }
  render() {
    return (
      <div className="BonusAppList">
        {this.state.loading?<Loading/>:null}
       <div className='header'>
         <div className='logo' onClick={()=>{
                    this.props.history.push('/');
                  }}>主页</div>
         <div className='avatar'  onClick={()=>{
                    this.props.history.push('/user');
                  }}
                  style={this.state.userData.imgUrl?{backgroundImage:'url('+this.state.userData.imgUrl+')',backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize:'contain'}:{}}
                  
                  ></div>
                  <div className='userName'
         onClick={()=>{
          this.props.history.push('/user');
        }}
        >
          {this.state.userData.memberName}
        </div>
        </div>
        <div className='container'>
              <h3>
                积分兑换
              </h3>
              <div className='total'>
                  <i  onClick={
                    ()=>{
                      this.props.history.push(this.state.bonusData.eventRoute)
                    }
                  } style={{backgroundImage:'url('+this.state.bonusData.eventIcon+')',backgroundSize:'contain',backgroundPosition:'center',backgroundRepeat:'no-repeat'}}></i>
                  <span
                  onClick={
                    ()=>{
                      this.props.history.push(this.state.bonusData.eventRoute)
                    }
                  }
                  >{this.state.bonusData.eventName}</span>
                  <span>可用：{this.state.bonusData.bonus}</span>
              </div>
              <div className='discription' dangerouslySetInnerHTML={{__html:this.state.discription}}></div>
              <div className='ctr'>
                <h4>请输入要兑换的金额</h4>
                <input
                  value={this.state.toUse}
                  onChange={
                    (v)=>{
                      this.judgeNum(v.target.value)
                    }
                  }
                />
              </div>
        </div>
        <div className='mainBtn' onClick={()=>{
                    this.submit();
                  }}>
          申请兑换积分
        </div>
      </div>
    );
  }
}

export default BonusApp;
